/** Copies props without the given keys, for props a component receives but must not spread onto its element. */
export function omitProps<T extends object, K extends keyof T>(
  props: T,
  ...keys: K[]
): Omit<T, K> {
  const rest = { ...props };
  for (const key of keys) {
    delete rest[key];
  }
  return rest;
}
